/**
 * API hooks для Web Widget.
 */

import { useQuery, useMutation, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import { client } from './client';

export interface WidgetMessage {
  id: string;
  actorRole: 'client' | 'operator' | 'ai';
  text: string;
  createdAt: string;
}

interface WidgetMessagesResponse {
  messages: WidgetMessage[];
}

export function useWidgetMessages(
  sessionId: string | null,
): UseQueryResult<WidgetMessage[], Error> {
  return useQuery({
    queryKey: ['widget-messages', sessionId],
    queryFn: async () => {
      const { data } = await client.get<WidgetMessagesResponse>(
        `/widget/sessions/${sessionId}/messages`
      );
      return data.messages;
    },
    enabled: !!sessionId,
    refetchInterval: 5_000,
  });
}

/** Ответ оператора; `duplicate` = такой ответ уже был отправлен. */
export interface WidgetReplyResult {
  messageId: string | null;
  duplicate: boolean;
  message?: string;
}

export function useSendWidgetReply(sessionId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (text: string) => {
      const { data } = await client.post<WidgetReplyResult>(
        `/widget/sessions/${sessionId}/reply`,
        { text },
      );
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['widget-messages', sessionId] });
    },
  });
}
